/**
 * Customer testimonials: mobile horizontal scroll, auto-advance.
 * Touch: vertical gestures scroll the page; horizontal gestures scroll cards.
 */
(function () {
  "use strict";

  var MOBILE_MQ = "(max-width: 1023px)";
  var VIEWPORT_SELECTOR = "[js-customer-testimonials-viewport]";
  var AXIS_LOCK_THRESHOLD = 8;

  function initViewport(viewport) {
    if (!viewport || viewport.dataset.customerTestimonialsInit === "true") return;
    viewport.dataset.customerTestimonialsInit = "true";

    var grid = viewport.querySelector(".customer-testimonials__grid");
    if (!grid) return;

    var items = grid.querySelectorAll(".customer-testimonials__card");
    if (!items.length) return;

    var paused = false;
    var timerId = null;
    var delayMs = parseInt(viewport.dataset.autoplayDelay, 10);
    if (isNaN(delayMs) || delayMs < 1000) delayMs = 5000;

    var touchStartX = 0;
    var touchStartY = 0;
    var scrollAxis = null;

    function isMobile() {
      return window.matchMedia(MOBILE_MQ).matches;
    }

    function prefersReducedMotion() {
      return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    }

    function getScrollStep() {
      var gap = parseFloat(getComputedStyle(grid).gap) || 16;
      return items[0].offsetWidth + gap;
    }

    function scrollNext() {
      if (!isMobile() || paused || items.length < 2) return;
      var maxScroll = viewport.scrollWidth - viewport.clientWidth;
      if (maxScroll <= 0) return;
      var step = getScrollStep();
      if (viewport.scrollLeft >= maxScroll - 2) {
        viewport.scrollTo({ left: 0, behavior: "smooth" });
      } else {
        viewport.scrollBy({ left: step, behavior: "smooth" });
      }
    }

    function stopAutoplay() {
      if (timerId !== null) {
        window.clearInterval(timerId);
        timerId = null;
      }
    }

    function startAutoplay() {
      stopAutoplay();
      if (!isMobile() || items.length < 2 || prefersReducedMotion()) return;
      timerId = window.setInterval(scrollNext, delayMs);
    }

    function pauseAutoplay() {
      paused = true;
      stopAutoplay();
    }

    function resumeAutoplay() {
      paused = false;
      startAutoplay();
    }

    function resetTouchState() {
      scrollAxis = null;
      touchStartX = 0;
      touchStartY = 0;
    }

    function onTouchStart(event) {
      if (!isMobile() || event.touches.length !== 1) return;
      resetTouchState();
      touchStartX = event.touches[0].clientX;
      touchStartY = event.touches[0].clientY;
    }

    function onTouchMove(event) {
      if (!isMobile() || event.touches.length !== 1) return;
      if (scrollAxis !== null) return;

      var dx = Math.abs(event.touches[0].clientX - touchStartX);
      var dy = Math.abs(event.touches[0].clientY - touchStartY);

      if (dx < AXIS_LOCK_THRESHOLD && dy < AXIS_LOCK_THRESHOLD) return;

      scrollAxis = dx > dy ? "x" : "y";
      if (scrollAxis === "x") pauseAutoplay();
    }

    function onTouchEnd() {
      if (scrollAxis === "x") resumeAutoplay();
      resetTouchState();
    }

    viewport.addEventListener("touchstart", onTouchStart, { passive: true });
    viewport.addEventListener("touchmove", onTouchMove, { passive: true });
    viewport.addEventListener("touchend", onTouchEnd, { passive: true });
    viewport.addEventListener("touchcancel", onTouchEnd, { passive: true });

    window.addEventListener("resize", function () {
      resetTouchState();
      if (isMobile()) {
        startAutoplay();
      } else {
        paused = false;
        stopAutoplay();
        viewport.scrollLeft = 0;
      }
    });

    if (isMobile()) startAutoplay();
  }

  function initAll(root) {
    var scope = root && root.querySelector ? root : document;
    scope.querySelectorAll(VIEWPORT_SELECTOR).forEach(initViewport);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
